module.exports = __webpack_public_path__ + "static/media/6780.96852349.jpg";